<!-- TODO: Replace Titan Compaonents with PrimeVue if we end up using this -->
<template>
  <div class="flex items-center justify-center min-h-screen bg-gray-100 w-full">
    <div
      class="text-center"
      style="
        border-radius: 8px;
        background: var(--White, #fff);
        box-shadow: 0px 4px 6px 0px rgba(0, 0, 0, 0.16);
        padding: 24px 60px 40px 60px;
        margin: 30px;
      "
    >
      <h2
        class="text-5xl font-bold mb-8"
        :style="{ color: mainColor }"
      >
        Candid API POC
      </h2>
      <p class="text-lg mb-6">
        This is a proof of concept for the Candid API. It is a work in progress and is not yet functional.
      </p>

      <!-- EIN Text Field -->
      <titan-text-input
        class="search"
        size="small"
        id="search_text"
        placeholder="API Key for Testing"
        hide-label=""
        style="margin-bottom: 20px"
        @inputValue="(val) => (testingKey = val.detail[0])"
      >
      </titan-text-input>
      <titan-text-input
        :key="resetFiltersCalled"
        class="search"
        size="small"
        form-type="search"
        id="search_text"
        placeholder="Search EIN"
        hide-label=""
        style="margin-bottom: 20px"
        @inputValue="(val) => (ein = val.detail[0])"
      >
      </titan-text-input>
      <titan-button
        :loading="searching"
        @click="searchCandidApi"
        >Search</titan-button
      >

      <div v-if="candidResponse">
        <h3 class="text-2xl mt-8">Candid Response</h3>
        <pre
          class="text-left"
          style="max-height: 300px; max-width: 950px; overflow: scroll"
        >
          {{ JSON.stringify(candidResponse, null, 2) }}
          </pre
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import api from '@/js/api';

const ein = ref('');
const testingKey = ref('');

const candidResponse = ref(null);

const searching = ref(false);

const searchCandidApi = async () => {
  console.log('Searching Candid API');
  searching.value = true;
  let response = await api.get('/candid/search', { params: { ein: ein.value, api_key: testingKey.value } });
  searching.value = false;
  console.log(response);
  candidResponse.value = response.data;
};
</script>

<style scoped>
titan-button {
  --btn-secondary-solid-bg: #0274d7;
  --btn-secondary-solid-border: #0274d7;
  --btn-secondary-solid-hover-bg: #0274d7;
  --btn-secondary-solid-hover-border: #0274d7;
  --btn-primary-outline-border: #0274d7;
  --btn-primary-outline-hover-border: #0274d7;
  --btn-primary-solid-bg: #0274d7;
  --btn-primary-solid-border: #0274d7;
  --btn-primary-solid-hover-bg: #0274d7;
  --btn-primary-solid-hover-border: #0274d7;
}

titan-text-input {
  --form-border-color-default: #000;
  --dropdown-item-color: #000;
  --dropdown-item-font: Poppins, sans-serif;
  --text-input-font: Poppins, sans-serif;
}
</style>
